export const API_BASE_URL =
    (window as any).RUNTIME_CONFIG?.API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    'http://localhost:8000';
